webpackJsonp([16417520386231456000],{

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/contact.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.contactQuery = undefined;
	
	var _templateObject = _taggedTemplateLiteral(['\n  text-align: center;\n  padding: 40px 0;\n  letter-spacing: 4px;\n  font-weight: 100;\n  color: #DDD;\n  text-transform: uppercase;\n'], ['\n  text-align: center;\n  padding: 40px 0;\n  letter-spacing: 4px;\n  font-weight: 100;\n  color: #DDD;\n  text-transform: uppercase;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n'], ['\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n  text-align: center;\n  color: #222!important;\n  padding: 40px 0;\n  opacity: 0.7;\n\n  @media screen and (max-width: 468px) {\n    padding: 20px;\n  }\n'], ['\n  text-align: center;\n  color: #222!important;\n  padding: 40px 0;\n  opacity: 0.7;\n\n  @media screen and (max-width: 468px) {\n    padding: 20px;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n  max-height: 100vh;\n  width: auto;\n  max-width: 100%;\n  margin: 0 auto;\n  display: block;\n'], ['\n  max-height: 100vh;\n  width: auto;\n  max-width: 100%;\n  margin: 0 auto;\n  display: block;\n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n  img {\n    border-radius: 50%;\n    display: block;\n    margin: 0 auto;\n    width: 250px;\n    height: 250px;\n    object-fit: cover;\n  }\n\n  h1 {\n    padding: 40px 0;\n    letter-spacing: 2px;\n    font-family: \'Pacifico\', cursive;\n    color: #5899E2;\n    text-transform: lowercase;\n    font-weight: 100;\n  }\n\n  p {\n    font-size: 16px;\n    line-height: 28px;\n    color: #222;\n    max-width: 900px;\n    margin: 0 auto;\n    display: block;\n  }\n\n  form {\n    max-width: 900px;\n    margin: 0 auto;\n    display: block;\n  }\n\n  label,\n  input,\n  textarea {\n    width: 100%;\n    display: block;\n  }\n\n  label {\n    margin-top: 40px;\n    margin-bottom: 10px;\n  }\n\n  input,\n  textarea {\n    padding: 20px;\n    outline: none;\n    &:focus {\n      border:1px solid #5899E2;\n    }\n    appearance: textfield;\n  }\n\n  input[type=submit] {\n    margin-top: 40px;\n    outline: none;\n    border: 0;\n    background: #FFF;\n    border:1px solid #5899E2;\n    letter-spacing: 2px;\n    font-family: \'Pacifico\', cursive;\n    color: #5899E2;\n    text-transform: lowercase;\n    font-weight: 100;\n  }\n\n'], ['\n  img {\n    border-radius: 50%;\n    display: block;\n    margin: 0 auto;\n    width: 250px;\n    height: 250px;\n    object-fit: cover;\n  }\n\n  h1 {\n    padding: 40px 0;\n    letter-spacing: 2px;\n    font-family: \'Pacifico\', cursive;\n    color: #5899E2;\n    text-transform: lowercase;\n    font-weight: 100;\n  }\n\n  p {\n    font-size: 16px;\n    line-height: 28px;\n    color: #222;\n    max-width: 900px;\n    margin: 0 auto;\n    display: block;\n  }\n\n  form {\n    max-width: 900px;\n    margin: 0 auto;\n    display: block;\n  }\n\n  label,\n  input,\n  textarea {\n    width: 100%;\n    display: block;\n  }\n\n  label {\n    margin-top: 40px;\n    margin-bottom: 10px;\n  }\n\n  input,\n  textarea {\n    padding: 20px;\n    outline: none;\n    &:focus {\n      border:1px solid #5899E2;\n    }\n    appearance: textfield;\n  }\n\n  input[type=submit] {\n    margin-top: 40px;\n    outline: none;\n    border: 0;\n    background: #FFF;\n    border:1px solid #5899E2;\n    letter-spacing: 2px;\n    font-family: \'Pacifico\', cursive;\n    color: #5899E2;\n    text-transform: lowercase;\n    font-weight: 100;\n  }\n\n']);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _header = __webpack_require__("./src/components/header.js");
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__("./src/components/footer.js");
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _container = __webpack_require__("./src/components/container.js");
	
	var _container2 = _interopRequireDefault(_container);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Title = _styledComponents2.default.h1(_templateObject);
	
	var Wrapper = _styledComponents2.default.div(_templateObject2);
	
	var CategoryFooter = (0, _styledComponents2.default)(_footer2.default)(_templateObject3);
	
	var Image = _styledComponents2.default.img(_templateObject4);
	
	var Content = _styledComponents2.default.div(_templateObject5);
	
	var Contact = function Contact(props) {
	  var categories = props.data.allWordpressCategory;
	  var pages = props.data.allWordpressPage;
	
	  // Todo the form should send to wordpres...
	
	  return _react2.default.createElement(
	    Wrapper,
	    null,
	    _react2.default.createElement(_header2.default, { pages: pages, categories: categories, primary: true, currentPage: props.location.pathname }),
	    _react2.default.createElement(
	      _container2.default,
	      null,
	      _react2.default.createElement(
	        Title,
	        null,
	        'Contacto'
	      ),
	      _react2.default.createElement(
	        Content,
	        null,
	        _react2.default.createElement(
	          'form',
	          { name: 'contact', action: 'thank-you', method: 'post', netlify: true },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Nome: ',
	              _react2.default.createElement('input', { type: 'text', name: 'name' })
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Email: ',
	              _react2.default.createElement('input', { type: 'email', name: 'email' })
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'label',
	              null,
	              'Mensagem: ',
	              _react2.default.createElement('textarea', { name: 'message' })
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement('input', { type: 'submit', value: 'Enviar' })
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(CategoryFooter, null)
	  );
	};
	
	exports.default = Contact;
	var contactQuery = exports.contactQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-contact-js-e235a4459e5b21c7ea00.js